module.exports = ".datepicker {\n  position: absolute;\n  top: 30px;\n  left: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/datepicker-window/datepicker-window.scss
// module id = ./src/app/components/datepicker-window/datepicker-window.scss
// module chunks = main